<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="EditWorkLvScore" :model="formData" :rules="rules" class="full-width-input" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="类型" prop="PaWorkLvScore.type">
            <el-select class="input-item" v-model="formData.PaWorkLvScore.type" :clearable="true" filterable :disabled="true"
              placeholder="类型" :loading="EditWorkLvScore.type.impl.loading"
              @visible-change="EditWorkLvScore.type.impl.onVisibleChange"
              @change="onTypeValueChange">
              <el-option v-for="item in EditWorkLvScore.type.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaWorkLvScore.type!=='post'">
          <el-form-item label="名称" prop="PaWorkLvScore.name">
            <el-input class="input-item" v-model="formData.PaWorkLvScore.name"
              :clearable="true" placeholder="名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaWorkLvScore.type==='post'">
          <el-form-item label="作品分工" prop="PaWorkLvScore.deptPostId">
            <el-select class="input-item" v-model="formData.PaWorkLvScore.deptPostId" :clearable="true" filterable
                       placeholder="作品分工" :loading="EditWorkLvScore.deptPostId.impl.loading"
                       @visible-change="EditWorkLvScore.deptPostId.impl.onVisibleChange"
                       @change="onDeptPostIdValueChange">
              <el-option v-for="item in EditWorkLvScore.deptPostId.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showLvA">
          <el-form-item :label="labelLvA" prop="PaWorkLvScore.lvA">
            <el-input-number class="input-item" v-model="formData.PaWorkLvScore.lvA" :clearable="true" :placeholder="labelLvA" :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showLvB">
          <el-form-item :label="labelLvB" prop="PaWorkLvScore.lvB">
            <el-input-number class="input-item" v-model="formData.PaWorkLvScore.lvB" :clearable="true" :placeholder="labelLvB" :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showLvC">
          <el-form-item :label="labelLvC" prop="PaWorkLvScore.lvC">
            <el-input-number class="input-item" v-model="formData.PaWorkLvScore.lvC" :clearable="true" :placeholder="labelLvC" :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showLvD">
          <el-form-item :label="labelLvD" prop="PaWorkLvScore.lvD">
            <el-input-number class="input-item" v-model="formData.PaWorkLvScore.lvD" :clearable="true" :placeholder="labelLvD" :min="0"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaWorkLvScore.type!=='root'">
          <el-form-item label="启用" prop="PaWorkLvScore.enableFlag">
            <el-radio-group class="input-item" v-model="formData.PaWorkLvScore.enableFlag" @change="onEnableFlagValueChange">
              <el-radio v-for="item in EditWorkLvScore.enableFlag.impl.dropdownList" :key="item.id" :label="item.id">
                {{item.name}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="formData.PaWorkLvScore.type!=='root'">
          <el-form-item label="排序" prop="PaWorkLvScore.sort">
            <el-input-number class="input-item" v-model="formData.PaWorkLvScore.sort"
                             :clearable="true"
                             placeholder="排序"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="描述" prop="PaWorkLvScore.detail">
            <el-input class="input-item" v-model="formData.PaWorkLvScore.detail"
              :clearable="true" placeholder="描述" type="textarea" :autosize="{ minRows: 4}"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="PaWorkLvScore.remark">
            <el-input class="input-item" v-model="formData.PaWorkLvScore.remark"
              :clearable="true" placeholder="备注"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="end">
            <el-button type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('EditWorkLvScore:EditWorkLvScore:update')"
              @click="onUpdateClick()">
              保存
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaWorkLvScoreController, DictionaryController } from '@/api';

export default {
  name: 'EditWorkLvScore',
  props: {
    id: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin],
  data () {
    return {
      showLvA: false,
      showLvB: false,
      showLvC: false,
      showLvD: false,
      labelLvA: 'A级',
      labelLvB: 'B级',
      labelLvC: 'C级',
      labelLvD: 'D级',
      formData: {
        PaWorkLvScore: {
          id: undefined,
          pid: undefined,
          tid: undefined,
          tname: undefined,
          gcode: undefined,
          code: undefined,
          type: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          deptPostId: undefined,
          enableFlag: 'Y',
          sort: 1,
          lvA: 0,
          lvB: 0,
          lvC: 0,
          lvD: 0,
          lvE: 0,
          lvF: 0,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          isDatasourceInit: false
        }
      },
      rules: {
        'PaWorkLvScore.name': [{required: true, message: '请输入名称', trigger: 'blur'}],
        'PaWorkLvScore.deptPostId': [{required: true, message: '请选择作品分工', trigger: 'blur'}],
        'PaWorkLvScore.lvA': [{required: true, message: '请输入A级', trigger: 'blur'}],
        'PaWorkLvScore.lvB': [{required: true, message: '请输入B级', trigger: 'blur'}],
        'PaWorkLvScore.lvC': [{required: true, message: '请输入C级', trigger: 'blur'}],
        'PaWorkLvScore.lvD': [{required: true, message: '请输入D级', trigger: 'blur'}]
      },
      EditWorkLvScore: {
        formFilter: {
        },
        formFilterCopy: {
        },
        type: {
          impl: new DropdownWidget(this.loadTypeDropdownList)
        },
        enableFlag: {
          impl: new DropdownWidget(this.loadEnableFlagDropdownList)
        },
        deptPostId: {
          impl: new DropdownWidget(this.loadDeptPostIdDropdownList)
        },
        BtnDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onSubmit (code) {
      this.$emit('submit', code);
    },
    /**
     * 类型下拉数据获取函数
     */
    loadTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_work_lv_score_type'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 类型选中值改变
     */
    onTypeValueChange (value) {
    },
    /**
     * 启用下拉数据获取函数
     */
    loadEnableFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYN(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 启用选中值改变
     */
    onEnableFlagValueChange (value) {
    },
    /**
     * 作品分工 下拉数据获取函数
     */
    loadDeptPostIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'work_post'};
        DictionaryController.dictSysIdDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 作品分工 选中值改变
     */
    onDeptPostIdValueChange (value) {
      let deptPostIdDictMap = findItemFromList(this.EditWorkLvScore.deptPostId.impl.dropdownList, this.formData.PaWorkLvScore.deptPostId, 'id')
      this.formData.PaWorkLvScore.name = deptPostIdDictMap.name;
    },
    /**
     * 更新编辑作品等级分值
     */
    refreshEditWorkLvScore (reloadData = false) {
      this.loadPaWorkLvScoreData().then(res => {
        if (!this.EditWorkLvScore.isInit) {
          // 初始化下拉数据
          this.EditWorkLvScore.enableFlag.impl.onVisibleChange(true).catch(e => {});
          this.EditWorkLvScore.type.impl.onVisibleChange(true).catch(e => {});
          this.EditWorkLvScore.deptPostId.impl.onVisibleChange(true).catch(e => {});
        }
        this.EditWorkLvScore.isInit = true;
      }).catch(e => {});
    },
    /**
     * 保存
     */
    onUpdateClick () {
      this.$refs.EditWorkLvScore.validate((valid) => {
        if (!valid) return;
        let paWorkLvScore = this.formData.PaWorkLvScore;
        if (paWorkLvScore.type === 'post') {

        }
        let params = {
          paWorkLvScoreDto: {
            id: this.id,
            pid: this.formData.PaWorkLvScore.pid,
            tid: this.formData.PaWorkLvScore.tid,
            tname: this.formData.PaWorkLvScore.tname,
            gcode: this.formData.PaWorkLvScore.gcode,
            code: this.formData.PaWorkLvScore.code,
            type: this.formData.PaWorkLvScore.type,
            name: this.formData.PaWorkLvScore.name,
            detail: this.formData.PaWorkLvScore.detail,
            remark: this.formData.PaWorkLvScore.remark,
            deptPostId: this.formData.PaWorkLvScore.deptPostId,
            lvA: this.formData.PaWorkLvScore.lvA,
            lvB: this.formData.PaWorkLvScore.lvB,
            lvC: this.formData.PaWorkLvScore.lvC,
            lvD: this.formData.PaWorkLvScore.lvD,
            lvE: this.formData.PaWorkLvScore.lvE,
            lvF: this.formData.PaWorkLvScore.lvF,
            sort: this.formData.PaWorkLvScore.sort,
            enableFlag: this.formData.PaWorkLvScore.enableFlag
          }
        };

        this.$confirm('是否保存修改?').then(res => {
          PaWorkLvScoreController.update(this, params).then(res => {
            this.$message.success('保存成功');
            this.refreshEditWorkLvScore();
            this.onSubmit(true);
          }).catch(e => {});
        }).catch(e => {});
      });
    },
    onResume () {
      this.refreshEditWorkLvScore(true);
    },
    /**
     * 获取作品级别分值详细信息
     */
    loadPaWorkLvScoreData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.PaWorkLvScore.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          PaWorkLvScoreController.view(this, params).then(res => {
            let PaWorkLvScore = {...res.data, isDatasourceInit: true};
            if (PaWorkLvScore.typeDictMap && this.EditWorkLvScore.type.impl.dirty) {
              this.EditWorkLvScore.type.impl.dropdownList = [PaWorkLvScore.typeDictMap];
            }
            this.EditWorkLvScore.enableFlag.impl.onVisibleChange(true).catch(e => {});
            if (PaWorkLvScore.deptPostIdDictMap && this.EditWorkLvScore.deptPostId.impl.dirty) {
              this.EditWorkLvScore.deptPostId.impl.dropdownList = [PaWorkLvScore.deptPostIdDictMap];
            }
            let x = PaWorkLvScore.type === 'type' ? '(分)' : '(%)';
            this.labelLvA = this.labelLvA.replace('(分)', '').replace('(%)', '') + x;
            this.labelLvB = this.labelLvB.replace('(分)', '').replace('(%)', '') + x;
            this.labelLvC = this.labelLvC.replace('(分)', '').replace('(%)', '') + x;
            this.labelLvD = this.labelLvD.replace('(分)', '').replace('(%)', '') + x;

            if (PaWorkLvScore.type === 'type') {
              this.showLvA = this.showLvB = this.showLvC = this.showLvD = true;
            } else if (PaWorkLvScore.type === 'post') {
              params.id = PaWorkLvScore.pid;
              PaWorkLvScoreController.view(this, params).then(pres => {
                let parentItem = {...pres.data};
                this.showLvA = parentItem.lvA > 0;
                this.showLvB = parentItem.lvB > 0;
                this.showLvC = parentItem.lvC > 0;
                this.showLvD = parentItem.lvD > 0;
              });
            }
            this.formData.PaWorkLvScore = PaWorkLvScore;
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.CourseSection.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaWorkLvScore: {
          id: undefined,
          pid: undefined,
          tid: undefined,
          tname: undefined,
          gcode: undefined,
          code: undefined,
          type: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          deptPostId: undefined,
          enableFlag: undefined,
          sort: undefined,
          lvA: undefined,
          lvB: undefined,
          lvC: undefined,
          lvD: undefined,
          lvE: undefined,
          lvF: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshEditWorkLvScore();
    }
  },
  computed: {
    // 初始化组件数据所需输入参数
    initPaWorkLvScoreParamChange () {
      return {
        id: this.id
      }
    },
    // 监听输入参数变化，用于数据变化后重新获取数据，如果存在多个数据组件或者数据组件使用不同的输入参数的优化，请拆分这里的代码
    formInputParamChange () {
      return {
        id: this.id
      }
    }
  },
  watch: {
    // 初始化组件数据所需输入参数，如果有多个初始化数据源需要优化，请修改这里的代码，只重置和更新相应的数据源数据
    initPaWorkLvScoreParamChange: {
      handler (newValue) {
        this.resetFormData();
        this.refreshEditWorkLvScore();
      },
      immediate: true
    },
    formInputParamChange: {
      handler (newValue) {
      },
      immediate: true
    }
  }
}
</script>
